import {
  BulkImportResponse,
  DropdownOption,
  NtIdEmployee,
  NtIdManagementResponse,
} from '../types/ntIdManagement.types';

/**
 * IMPORTANT:
 * This file contains ONLY synthetic/dummy data.
 *
 * Do not add real employee names, employee codes,
 * email addresses, NTIDs, managers, or other
 * organization-sensitive information here.
 *
 * This file is intended for local/mock development only.
 */

export const mockNtIdEmployees: NtIdEmployee[] = [
  {
    employeeNetworkMappingId: 1001,
    employeeCode: 'TEST001',
    employeeName: 'Test Employee One',
    email: 'test.employee.one@example.com',
    ntIds: ['TESTNT001'],
    role: 'Employee',
    status: 'Active',
    team: 'Test Team A',
    reportingManager: 'Test Manager One',
    shift: 'General',
  },
  {
    employeeNetworkMappingId: 1002,
    employeeCode: 'TEST002',
    employeeName: 'Test Employee Two',
    email: 'test.employee.two@example.com',
    ntIds: ['TESTNT002'],
    role: 'Rep. Manager',
    status: 'Active',
    team: 'Test Team A',
    reportingManager: '',
    shift: 'General',
  },
  {
    employeeNetworkMappingId: 1003,
    employeeCode: 'TEST003',
    employeeName: 'Test Employee Three',
    email: 'test.employee.three@example.com',
    ntIds: ['TESTNT003'],
    role: 'Rep. Manager',
    status: 'Active',
    team: 'Test Team B',
    reportingManager: '',
    shift: 'General',
  },
  {
    employeeNetworkMappingId: 1004,
    employeeCode: 'TEST004',
    employeeName: 'Test Employee Four',
    email: 'test.employee.four@example.com',
    ntIds: ['TESTNT004'],
    role: 'Employee',
    status: 'Inactive',
    team: 'Test Team C',
    reportingManager: 'Test Manager Two',
    shift: 'Night',
  },
  {
    employeeNetworkMappingId: 1005,
    employeeCode: 'TEST005',
    employeeName: 'Test Administrator',
    email: 'test.admin@example.com',
    ntIds: ['TESTNT005'],
    role: 'Admin',
    status: 'Active',
    team: 'Test Administration',
    reportingManager: '',
    shift: 'General',
  },
];

export const mockRoles: DropdownOption[] = [
  {
    id: 1,
    label: 'Employee',
    value: 'Employee',
  },
  {
    id: 2,
    label: 'Rep. Manager',
    value: 'Rep. Manager',
  },
  {
    id: 3,
    label: 'Admin',
    value: 'Admin',
  },
];

export const mockStatuses: DropdownOption[] = [
  {
    id: 1,
    label: 'Active',
    value: 'Active',
  },
  {
    id: 2,
    label: 'Inactive',
    value: 'Inactive',
  },
];

export const mockShifts: DropdownOption[] = [
  {
    id: 1,
    label: 'General',
    value: 'General',
  },
  {
    id: 2,
    label: 'Night',
    value: 'Night',
  },
];

export const mockTeams: DropdownOption[] = [
  {
    id: 1,
    label: 'Test Team A',
    value: 'Test Team A',
  },
  {
    id: 2,
    label: 'Test Team B',
    value: 'Test Team B',
  },
  {
    id: 3,
    label: 'Test Team C',
    value: 'Test Team C',
  },
];

export const mockReportingManagers: DropdownOption[] = [
  {
    id: 1,
    label: 'Test Manager One',
    value: 'Test Manager One',
  },
  {
    id: 2,
    label: 'Test Manager Two',
    value: 'Test Manager Two',
  },
];

export const mockNtIdManagementResponse: NtIdManagementResponse = {
  employees: mockNtIdEmployees,
  totalCount: mockNtIdEmployees.length,
};

export const mockBulkImportResponse: BulkImportResponse = {
  totalRecords: 5,
  addedRecords: 3,
  updatedRecords: 2,
  failedRecords: 0,
  message: 'Bulk import completed successfully.',
};